import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ServerRoutes } from "src/app/ServerRoutes";
import { UserService } from "../user.service";

@Injectable({
	providedIn: "root",
})
export class AgendaService {
	constructor(
		private http: HttpClient,
		private routes: ServerRoutes,
		private userService: UserService
	) {}

	newAgenda(agenda) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.postAgenda,
				agenda,
				this.userService.getHeader()
			)
		);
	}

	getAgenda() {
		return this.routes.requisicaoHTTP(
			this.http.get(this.routes.getAgenda, this.userService.getHeader())
		);
	}
}
